import photos from '../data/photos.json';
import collections from '../data/collections.json';

/**
 * Photos carry tags: `collection` or `collection/sub` (e.g. "travels/japan",
 * which implies "travels"). Each main collection keeps a manual `order` of
 * photo ids; a sub-collection reuses it, filtered. Photos missing from the
 * order are appended in photos.json order.
 */

const photosById = new Map(photos.map((p) => [p.id, p]));

export const getCollections = () => collections;

export const getCollection = (slug) => collections.find((c) => c.slug === slug);

export const getName = (entry, language) =>
  entry?.name?.[language] || entry?.name?.en || entry?.slug || '';

const hasTag = (photo, slug, sub) =>
  photo.tags.some((tag) =>
    sub ? tag === `${slug}/${sub}` : tag === slug || tag.startsWith(`${slug}/`)
  );

export const getCollectionPhotos = (slug, sub) => {
  const collection = getCollection(slug);
  if (!collection) return [];

  const order = collection.order || [];
  const ordered = order
    .map((id) => photosById.get(id))
    .filter((p) => p && hasTag(p, slug, sub));
  const inOrder = new Set(order);
  const rest = photos.filter((p) => !inOrder.has(p.id) && hasTag(p, slug, sub));

  return [...ordered, ...rest];
};

// Sub-collections of `slug` that contain at least one photo, in collections.json order
export const getSubCollections = (slug) =>
  (getCollection(slug)?.children || []).filter((child) =>
    photos.some((p) => hasTag(p, slug, child.slug))
  );

// Cover photo of a collection / sub-collection: its `cover` photo id (set in the
// Studio) if that photo is still in it, else its first photo
export const getCover = (slug, sub) => {
  const photos = getCollectionPhotos(slug, sub);
  const collection = getCollection(slug);
  const entry = sub ? collection?.children?.find((c) => c.slug === sub) : collection;
  return photos.find((p) => p.id === entry?.cover) || photos[0] || null;
};

// Logical path, mapped to the encrypted file by encUrl()
export const photoPath = (photo) => `/images-optimized/photos/${photo.file}`;
